import React from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setAppStatus } from "../../appStatusManager/actions/appStatus_action";
import { useWindowEvent } from "../../hooks/windowEvents";
import Routing from "../../routing/routing";
import CryptoJS from "crypto-js";
const devTypes = ["initDtLocal"];

let AppAxios = axios.create({
  defaultInterceptors: true,
  headers: { "Access-Control-Allow-Origin": "*" },
  baseURL: process.env.REACT_APP_URL_API
});

const updateTokenAxios = (newToken) => {
  if (newToken !== "") {
    const tokenApi = `Bearer ${newToken}`;
    AppAxios.defaults.headers.common["Authorization"] = tokenApi;
  }
};

const updateToken = () => {
  if (
    process.env.NODE_ENV === "development" &&
    window.location === window.parent.location
  ) {
    return null;
  }

  return new Promise((resolve, reject) => {
    window.parent.postMessage(`onSecurity:updateToken()`, "*");
    window.addEventListener("message", (event) => {
      if (
        event.data &&
        event.data.type &&
        devTypes.indexOf(event.data.type) < 0
      ) {
        return;
      }
      if (
        event.data &&
        typeof event.data &&
        typeof event.data === "string" &&
        event.data.startsWith("onSecurity:updateToken>")
      ) {
        const token = event.data.replace(/onSecurity:updateToken>/g, "");
        if (token) {
          resolve(token);
        } else {
          reject("no se encontró el token");
        }
      }
    });
  });
};

AppAxios.interceptors.request.use(
  async (config) => {
    try {
      const token = await updateToken();
      if (token) {
        updateTokenAxios(token);
      }
    } catch (error) {
      console.log(
        "Failed to refresh the token, or the session has expired",
        error
      );
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY);
const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_INITVECTOR);
const decryptData = (encryptedData) => {
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });
  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedText);
};

AppAxios.interceptors.response.use(
  (response) => {
    const isEncrypted = response.headers["x-encrypted"];
    if (isEncrypted === "true" && response.status === 200) {
      //console.log("respuesta backend encriptada: ", response.data);
      // Asume que los datos están encriptados en la respuesta
      const decryptedData = decryptData(response.data);
      //console.log("respuesta backend desencriptada por front: ", decryptedData);
      return { ...response, data: decryptedData };
    } else {
      //console.log("respuesta backend sin encriptación: ", response.data);
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

setTimeout(function () {
  window.parent.postMessage(`onInit:try`, "*");
}, 500);

function AppInit() {
  const dispatch = useDispatch();
  const appInitReady = useSelector((state) => state.appStatus.initialized);

  const receiveMessage = (event) => {
    if (
      appInitReady ||
      (event.data && event.data.type && devTypes.indexOf(event.data.type) < 0)
    ) {
      return;
    }
    if (devTypes.indexOf(event.data.type) >= 0) {
      //DATOS DUMMY
      updateTokenAxios(process.env.REACT_APP_DEFAULT_TOKEN);
      const sesion = {
        UsuarioActual: {
          Persona: {
            Nombre: "Pepe",
            ApellidoPaterno: "Pérez",
            ApellidoMaterno: "Zurita",
            Rut: "12325522-7",
          },
        },
        PerfilActual: {
          idtipoPerfil: 1,
        },
      };
      /*** Eliminar en proyecto oficial ***/
      console.log("SesionDummy", sesion);
      dispatch(
        setAppStatus({
          allData: { sesion },
        })
      );
    } else if (event.data && typeof event.data === "string") {
      let obj = null;
      try {
        obj = JSON.parse(event.data);
      } catch (error) {
        obj = null;
      }
      if (obj) {
        /*** Eliminar en proyecto oficial ***/
        console.log("********* datos Recibidos: ", obj);
        updateTokenAxios(obj.token);
        dispatch(
          setAppStatus({
            allData: { ...obj.allData },
          })
        );
      }
    }
  };
  useWindowEvent("message", receiveMessage);
  if (window.location === window.parent.location) {
    receiveMessage({ data: { type: "initDtLocal" } });
  }

  function GetApp(props) {
    if (props.initReady) {
      return <Routing />;
    } else {
      return <p>...Started</p>;
    }
  }

  return (
    <div className="app mx-auto pt-1 col-12 col-lg-12 col-xl-12 ">
      <div className="app mx-auto pt-1 col-12 col-lg-11 col-xl-9 ">
        <GetApp initReady={appInitReady} />
      </div>
      <div style={{backgroundColor: "#001c41", padding: "24px 78px"}}>
        <div class="container" style={{ maxWidth: "1400px", marginLeft: "10%", marginRight: "10%" }}>
          <div class="panel-footer row"><div class="col-6 col-sm-5 col-md-4 col-lg-4">
            <img src="data:image/png;base64,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" alt="Chile lo hacemos todos" style={{ maxHeight: "100%", padding: "1%", marginLeft: "-15px", maxWidth: "100%" }} />
          </div>
            <div class="col-5 col-sm-5 offset-sm-1 col-md-4 offset-md-3 col-lg-3 offset-lg-5">
              <p style={{ color: "#FFFFFF", fontSize: ".8em", marginBottom: "16px", fontStyle: "Roboto" }}>Dirección del Trabajo, Gobierno de Chile</p>
              <p style={{ color: "#FFFFFF", fontSize: ".8em", marginBottom: "16px", fontStyle: "Roboto" }}>Agustinas 1253, Santiago, Chile.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { AppAxios, AppInit };
